import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useEventLeads(eventId, { filter, sortBy: sortFunction } = {}) {
    const selector = useCallback((state) => state.events[eventId]?.leads?.list, [eventId]),
        leads = useSelector(selector);

    return useMemo(() => {
        let result = leads ?? [];

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [leads, filter, sortFunction]);
}
